<template>
  <div class="project-list">
    <adminListing v-if="isAdmin" :clientId="client_id" />
    <clientListing v-else :clientId="client_id" />
  </div>
</template>
<script>
import adminListing from "./admin-listing.vue";
import clientListing from "./client-listing.vue";
export default {
  props: ["client_id"],
  components: {
    adminListing,
    clientListing,
  },
  computed: {
    isAdmin() {
      return this.isUserType("A") || false;
    },
  },
};
</script>
